/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Enabled_YesInputs */

const en_users_enabled_yes = /** @type {(inputs: Users_Enabled_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const pt_br2_users_enabled_yes = /** @type {(inputs: Users_Enabled_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Users_Enabled_YesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_enabled_yes = /** @type {((inputs?: Users_Enabled_YesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Enabled_YesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_enabled_yes(inputs)
	return pt_br2_users_enabled_yes(inputs)
});